import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSwipeable } from 'react-swipeable';
import axios from 'axios';
import { CommentSection } from 'react-comments-section'; // Snippet import
// import 'react-comments-section/dist/index.css'; // Snippet import CSS
import './Comment.css'; // Snippet import CSS
import "../CommentSection/Styles/App.scss";
import Comment from "../CommentSection/Comment";
import AddComment from "../CommentSection/AddComment";

// import { CommentSection } from '../../components/CommentSection'; // Snippet import
// import '../../components/CommentSection/dist/index.css'; // Snippet import CSS

const config = require('../../config'); // Make sure this path is correct

// --- Components copied/adapted from Reel.js ---
const IconPlaceholder = ({ label, count, onClick }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px', cursor: 'pointer' }} onClick={onClick}>
    <div style={{
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      marginBottom: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '20px',
      color: 'white'
    }}>
      {label}
    </div>
    {count !== undefined && <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.7)' }}>{count}</span>}
  </div>
);

const SoundIconPlaceholder = ({ imageUrl = 'https://via.placeholder.com/50' }) => (
    <div style={{
        width: '45px',
        height: '45px',
        borderRadius: '50%',
        border: '2px solid rgba(255, 255, 255, 0.5)',
        padding: '3px',
        marginTop: '10px'
    }}>
        <img
            src={imageUrl}
            alt="Sound cover"
            style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
        />
    </div>
);

// --- Styles ---
const styles = {
  reelContainer: {
    width: '100%',
    height: '100%',
    maxWidth: '450px',
    maxHeight: '800px',
    backgroundColor: '#111',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  reelContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    zIndex: 1,
  },
  overlay: {
    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
    zIndex: 2, display: 'flex', pointerEvents: 'none',
  },
  topNav: {
      position: 'absolute', top: '15px', left: 0, width: '100%', display: 'flex',
      justifyContent: 'center', gap: '15px', color: 'rgba(255, 255, 255, 0.7)',
      fontWeight: 'bold', fontSize: '16px', textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
      pointerEvents: 'auto',
  },
  sidebar: {
    position: 'absolute', bottom: '15px', right: '10px', display: 'flex',
    flexDirection: 'column', alignItems: 'center',
    pointerEvents: 'auto',
  },
  bottomInfo: {
      position: 'absolute', bottom: '15px', left: '15px', right: '80px',
      color: 'white', textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
      pointerEvents: 'auto',
  },
  username: {
    fontWeight: 'bold', fontSize: '16px', marginBottom: '5px', display: 'flex',
    alignItems: 'center', gap: '5px'
  },
  caption: {
    fontSize: '14px', marginBottom: '10px', lineHeight: '1.3',
    maxHeight: '6em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  soundInfo: {
    display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
  },
  closeButton: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      zIndex: 20,
      background: 'rgba(0, 0, 0, 0.5)',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '35px',
      height: '35px',
      fontSize: '24px',
      lineHeight: '40px',
      textAlign: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
  },
  navButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 3,
      background: 'rgba(0, 0, 0, 0.6)', // Increased opacity
      color: 'white',
      border: 'none',
      padding: '10px',
      cursor: 'pointer',
      borderRadius: '50%',
      fontSize: '28px', // Increased font size
      lineHeight: '1',
      pointerEvents: 'auto',
      width: '50px', // Increased size
      height: '50px', // Increased size
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
  },
  prevButton: { left: '10px' },
  nextButton: { right: '10px' },
  commentSectionContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '65%',
    backgroundColor: '#FFFFFF',
    color: '#000000',
    zIndex: 15,
    overflowY: 'hidden',
    borderTop: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px -2px 10px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease-out',
    // --- Added for rounded corners ---
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  commentSectionHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
    borderBottom: '1px solid #f0f0f0',
    backgroundColor: '#f9f9f9',
    minHeight: '25px',
    position: 'relative',
    cursor: 'grab',
    // --- Added for rounded corners ---
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  commentDragIcon: {
    width: '50px',
    height: '6px',
    backgroundColor: '#cccccc',
    borderRadius: '5px',
  },
  commentSectionContent: {
    flexGrow: 1,
    overflowY: 'auto',
    // paddingBottom: '80px', // Increased padding to account for addCommentContainer height
  },
  dotsContainer: {
    position: 'absolute',
    bottom: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    zIndex: 3,
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.5)',
  },
  activeDot: {
    backgroundColor: 'white',
  },
  commentLikeButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    color: '#666',
  },

  commentSectionContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '65%',
    backgroundColor: '#FFFFFF',
    color: '#000000',
    zIndex: 15,
    overflowY: 'hidden',
    
    borderTop: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px -2px 10px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease-out',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  commentSectionContent: {
    flexGrow: 1,
    overflowY: 'auto',
    // paddingBottom: '60px', // Add padding to prevent content from being hidden under AddComment
    paddingBottom: '100px', // Increased padding to account for addCommentContainer height
    overflowX: 'hidden', // Add this line to disable horizontal swiping
  },
  addCommentContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: '#fff',
    padding: '10px',
    borderTop: '1px solid #e0e0e0',
    zIndex: 1000,
  },

};

// --- Main Popup Component ---
const Popup = ({ property, setShowPopup, goToPreviousMarker, goToNextMarker, currentMarkerIndex }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(true);
  const audioRef = useRef(null);
  const videoRef = useRef(null);

  const cleanupAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.removeAttribute('src');
      audioRef.current.load();
      audioRef.current = null;
      setIsAudioPlaying(false);
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      // videoRef.current.play()
      // audioRef.current.pause()
      cleanupAudio();
      // .catch(error => {
      //   console.error('Autoplay failed:', error);
      // });
    }
    // audioRef.current.pause()

  }, [currentMarkerIndex]);

  useEffect(() => {
    const preventTouchmove = (e) => {
      e.preventDefault();
    };

    if (isPopupOpen) {
      document.addEventListener('touchmove', preventTouchmove, { passive: false });
    }

    return () => {
      document.removeEventListener('touchmove', preventTouchmove);
    };
  }, [isPopupOpen]);

  const [comments, updateComments] = useState([]);
  const [deleteModalState, setDeleteModalState] = useState(false);

  const commentData = {
    currentUser: {
      username: "juliusomo"
    },
    comments: [
      {
        id: 1,
        content: "Impressive! Though it seems the drag feature could be improved...", // content
        createdAt: "23 November 2021", // createdAt
        score: 12, // likeCount
        username: "amyrobson", // author
        currentUser: false,
        replies: []
      },
      {
        id: 2,
        content: "Woah, your project looks awesome! How long have you been coding for?",
        createdAt: "5 December 2021",
        score: 5,
        username: "maxblagun",
        currentUser: false,
        replies: [
          {
            id: 3,
            content: "@maxblagun, If you're still new, I'd recommend focusing on the fundamentals...",
            createdAt: "18 December 2021",
            score: 4,
            username: "ramsesmiron",
            currentUser: false,
            replies: []
          },
          {
            id: 4,
            content: "@ramsesmiron, I couldn't agree more with this...",
            createdAt: "30 December 2021",
            score: 2,
            username: "juliusomo",
            currentUser: true,
            replies: []
          }
        ]
      }
    ]
  };


  const getData = async () => {
    // const res = await fetch("./data/data.json");
    // const data = await res.json();
    // updateComments(data.comments);
    updateComments(commentData.comments);

  };

  useEffect(() => {
    localStorage.getItem("comments") !== null
      ? updateComments(JSON.parse(localStorage.getItem("comments")))
      : getData();
  }, []);

  useEffect(() => {
    localStorage.setItem("comments", JSON.stringify(comments));
    deleteModalState
      ? document.body.classList.add("overflow--hidden")
      : document.body.classList.remove("overflow--hidden");
  }, [comments, deleteModalState]);

  // update score
  let updateScore = (score, id, type) => {
    let updatedComments = [...comments];

    if (type === "comment") {
      updatedComments.forEach((data) => {
        if (data.id === id) {
          data.score = score;
        }
      });
    } else if (type === "reply") {
      updatedComments.forEach((comment) => {
        comment.replies.forEach((data) => {
          if (data.id === id) {
            data.score = score;
          }
        });
      });
    }
    updateComments(updatedComments);
  };

  // add replies
  let updateReplies = (replies, id) => {
    let updatedComments = [...comments];
    updatedComments.forEach((data) => {
      if (data.id === id) {
        data.replies = [...replies];
      }
    });
    updateComments(updatedComments);
  };

  // edit comment
  let editComment = (content, id, type) => {
    let updatedComments = [...comments];

    if (type === "comment") {
      updatedComments.forEach((data) => {
        if (data.id === id) {
          data.content = content;
        }
      });
    } else if (type === "reply") {
      updatedComments.forEach((comment) => {
        comment.replies.forEach((data) => {
          if (data.id === id) {
            data.content = content;
          }
        });
      });
    }

    updateComments(updatedComments);
  };

  // delete comment
  let commentDelete = (id, type, parentComment) => {
    let updatedComments = [...comments];
    let updatedReplies = [];

    if (type === "comment") {
      updatedComments = updatedComments.filter((data) => data.id !== id);
    } else if (type === "reply") {
      comments.forEach((comment) => {
        if (comment.id === parentComment) {
          updatedReplies = comment.replies.filter((data) => data.id !== id);
          comment.replies = updatedReplies;
        }
      });
    }

    updateComments(updatedComments);
  };


  // console.log('######## popup_v2.js property #########')
  // console.log(property)

  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [likeCount, setLikeCount] = useState(property.likeCount || 0);
  const [commentPanelVisible, setCommentPanelVisible] = useState(false);
  const [rawComments, setRawComments] = useState([]);
  const [commentLikes, setCommentLikes] = useState({}); // Track comment likes
  const API_ENDPOINT = config.getAllURL + 'api/comment';

  const handleCommentLike = async (commentId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('You must be logged in to like this comment.');
        loginAction.onLogin();
        return;
      }

      // Assuming there's an API endpoint to update the like count for comments
      const API_LIKE_COMMENT_ENDPOINT = config.getAllURL + 'api/comment/like'; // Replace with the actual endpoint

      await axios.post(API_LIKE_COMMENT_ENDPOINT, {
        commentId: commentId,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Update the local state
      setCommentLikes(prevLikes => ({
        ...prevLikes,
        [commentId]: (prevLikes[commentId] || 0) + 1,
      }));

    } catch (error) {
      console.error('Error liking comment:', error.response ? error.response.data : error.message);
      alert('Failed to like comment. Please try again.');
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleNextMedia(),
    onSwipedRight: () => handlePrevMedia(),
    onMouseUp: () => goToNextMarker(),
    onMouseDown: () => goToPreviousMarker(),
    onSwipedUp: () => goToNextMarker(),
    // onSwipedUp: (e) => {
    //   e.event.preventDefault();
    //   goToNextMarker();
    // },    
    onSwipedDown: (e) => {
      e.event.preventDefault();
      goToPreviousMarker();
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  // CRITICAL TODO: Replace with actual current user data from your auth system/context
  const currentUserData = useMemo(() => ({
    currentUserId: 'PLEASE_REPLACE_USER_ID',
    currentUserImg: `https://ui-avatars.com/api/name=User&background=random&color=fff`,
    currentUserProfile: '#',
    currentUserFullName: 'Current User Name'
  }), []);

  const isUnmounting = useRef(false); // fix onclose popup stop video
  useEffect(() => {
    // Track unmount
    return () => {
      isUnmounting.current = true;
    };
  }, []);


  useEffect(() => {
    const fetchComments = async () => {
      if (!property._id) return;
      try {
        const response = await axios.get(`${API_ENDPOINT}?mapMarker=${property._id}`);
        setRawComments(response.data || []);
      } catch (error) {
        console.error('Error fetching comments:', error);
        setRawComments([]);
      }
    };

    fetchComments();
  }, [commentPanelVisible, property._id, API_ENDPOINT]);

  // Effect to handle soundtrack playback
  useEffect(() => {
    const currentMedia = property.media?.[currentMediaIndex];
    const soundtrackUrl = 'https://' + property.soundtrackUrl;

    const isImage = currentMedia && (currentMedia.type === 'image' || /\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url));
    const isVideo = currentMedia && (currentMedia.type === 'video' && !/\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url));

    // const cleanupAudio = () => {
    //   if (audioRef.current) {
    //     audioRef.current.pause();
    //     audioRef.current.removeAttribute('src');
    //     audioRef.current.load();
    //     audioRef.current = null;
    //     setIsAudioPlaying(false);
    //   }
    // };

    // if (soundtrackUrl && soundtrackUrl.trim() !== '' && isImage) {
    if (soundtrackUrl && soundtrackUrl.trim() !== '' ) {
    if (!audioRef.current) {
        audioRef.current = new Audio(soundtrackUrl);
        audioRef.current.loop = true;
        audioRef.current.volume = 0.5;
        audioRef.current.onplaying = () => setIsAudioPlaying(true);
        audioRef.current.onpause = () => setIsAudioPlaying(false);
        audioRef.current.onerror = (e) => {
          console.error('Audio playback error:', e);
          setIsAudioPlaying(false);
        };
        audioRef.current.play().catch(error => {
          console.error('Audio play failed:', error);
        });
      }
    } 
    // else if (isVideo) {
    //   if (audioRef.current) {
    //     audioRef.current.pause();
    //   }
    // } 
    else {
      cleanupAudio();
    }


    return () => {
      if (isUnmounting.current) {
        // Component is unmounting => cleanup audio
        cleanupAudio();
      } else {
        // Dependency change (e.g., image navigation)
        // Only cleanup if media is NOT image
        if (!isImage) {
          cleanupAudio();
        }
        // else: keep playing audio on image change
      }
    };

    // return () => {
    //   if (!isImage) cleanupAudio();

    // };

    // return () => {
    //   cleanupAudio();
    // };

    // return cleanupAudio;

  }, [property.soundtrackUrl, currentMediaIndex]);


  // useEffect(() => {
  //   const currentMedia = property.media?.[currentMediaIndex];
  //   const soundtrackUrl = 'https://' + property.soundtrackUrl;

  //   const isImage = currentMedia && (currentMedia.type === 'image' || /\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url));
  //   const isVideo = currentMedia && (currentMedia.type === 'video' && !/\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url));

  //   const cleanupAudio = () => {
  //     if (audioRef.current) {
  //       audioRef.current.pause();
  //       audioRef.current.removeAttribute('src');
  //       audioRef.current.load();
  //       audioRef.current = null;
  //       setIsAudioPlaying(false);
  //     }
  //   };

  //   // Play soundtrack if present and currentMedia is image
  //   if (soundtrackUrl && soundtrackUrl.trim() !== '' && isImage) {
  //     // Only create new Audio object if audioRef is null
  //     if (!audioRef.current) {
  //       audioRef.current = new Audio(soundtrackUrl);
  //       audioRef.current.loop = true;
  //       audioRef.current.volume = 0.5;
  //       audioRef.current.onplaying = () => setIsAudioPlaying(true);
  //       audioRef.current.onpause = () => setIsAudioPlaying(false);
  //       audioRef.current.onerror = (e) => {
  //         console.error('Audio playback error:', e);
  //         setIsAudioPlaying(false);
  //       };
  //       audioRef.current.play().catch(error => {
  //         console.error('Audio play failed:', error);
  //       });
  //     }
  //   } else if (isVideo) {
  //     // Pause soundtrack if media is video
  //     if (audioRef.current) {
  //       audioRef.current.pause();
  //     }
  //   } else {
  //     // Pause for unsupported or missing media
  //     cleanupAudio();
  //   }

  //   return () => {
  //     // Don’t cleanup on image change to keep soundtrack playing
  //     if (!isImage) cleanupAudio();
  //   };
  // }, [property.soundtrackUrl, currentMediaIndex]);

  // old, replaying audio err on image navigation
    // useEffect(() => {
    //   const currentMedia = property.media?.[currentMediaIndex];
    //   // const soundtrackUrl = property.soundtrackUrl;
    //   const soundtrackUrl = 'https://' + property.soundtrackUrl;


    //   console.log('useEffect: Handling soundtrack playback', { soundtrackUrl, currentMedia, currentMediaIndex });

    //   // Cleanup function
    //   const cleanupAudio = () => {
    //     console.log('cleanupAudio: Pausing and cleaning up audioRef');
    //     if (audioRef.current) {
    //       audioRef.current.pause();
    //       audioRef.current.removeAttribute('src');
    //       audioRef.current.load();
    //       audioRef.current = null;
    //       setIsAudioPlaying(false);
    //     }
    //   };

    //   // Check if soundtrack exists and is not empty
    //   if (soundtrackUrl && soundtrackUrl.trim() !== '') {
    //     if (!audioRef.current) {
    //       audioRef.current = new Audio(soundtrackUrl);
    //       audioRef.current.loop = true; // Loop audio for images
    //       audioRef.current.volume = 0.5; // Optional: set a default volume
    //       audioRef.current.onplaying = () => setIsAudioPlaying(true);
    //       audioRef.current.onpause = () => setIsAudioPlaying(false);
    //       audioRef.current.onended = () => setIsAudioPlaying(false);
    //       audioRef.current.onerror = (e) => {
    //         console.error('Audio playback error:', e);
    //         setIsAudioPlaying(false);
    //       };
    //     } else {
    //        // If audioRef exists, update source if needed and prepare for playback
    //        if (audioRef.current.src !== soundtrackUrl) {
    //           audioRef.current.src = soundtrackUrl;
    //           audioRef.current.load();
    //        }
    //        audioRef.current.loop = true; // Ensure loop is true for images
    //     }


    //     if (currentMedia) {
    //       // if (currentMedia.type === 'image' || /\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url)) {
    //       //   // If media is an image, play audio immediately
    //       //   audioRef.current.play().catch(error => console.error('Audio play failed:', error));
    //       // } 
    //       if (currentMedia.type === 'image' || /\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url)) {
    //         if (audioRef.current.paused) {
    //           audioRef.current.play().catch(error => console.error('Audio play failed:', error));
    //         }
    //       }
    //       else if (currentMedia.type === 'video' && !/\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url)) {
    //         // If media is a video, audio playback will be handled by the video's onCanPlayThrough event
    //         // Ensure audio is paused initially
    //         audioRef.current.pause();
    //       } else {
    //          // For other media types or if media is missing, pause audio
    //          cleanupAudio();
    //       }
    //     } else {
    //        // If no media, pause audio
    //        cleanupAudio();
    //     }

    //   } else {
    //     // If no soundtrack URL, ensure audio is stopped
    //     cleanupAudio();
    //   }

    //   // Cleanup when component unmounts or dependencies change
    //   return cleanupAudio;

    // }, [property.soundtrackUrl, currentMediaIndex, property.media]); // Dependencies

  const transformCommentsForSection = (apiComments) => {
    if (!Array.isArray(apiComments)) return [];
    const commentMap = {};
    const topLevelComments = [];

    apiComments.forEach(comment => {
      const authorName = comment.author?.username || 'Anonymous';
      commentMap[comment._id] = {
        userId: comment.author?._id || 'unknownUserId',
        comId: comment._id,
        fullName: authorName,
        avatarUrl: comment.author?.profilePicture || `https://ui-avatars.com/api/?name=${encodeURIComponent(authorName)}&background=random&color=fff`,
        text: comment.content,
        timestamp: comment.createdAt ? new Date(comment.createdAt).toISOString() : new Date().toISOString(),
        replies: [],
        likeCount: comment.likeCount || 0, // Add like count
        onLike: () => handleCommentLike(comment._id), // Add like handler
        commentId: comment._id, // Add comment ID
        createdAt: comment.createdAt,
        content: comment.content,
        username: authorName,
        score: comment.likeCount || 0, 

      };
    });

    apiComments.forEach(comment => {
      if (comment.parentComment && commentMap[comment.parentComment._id]) {
        commentMap[comment.parentComment._id].replies.push(commentMap[comment._id]);
      } else if (comment.parentComment && commentMap[comment.parentComment]) {
          commentMap[comment.parentComment].replies.push(commentMap[comment._id]);
      } else if (!comment.parentComment) {
        topLevelComments.push(commentMap[comment._id]);
      }
    });
    return topLevelComments;
  };

  const commentDataForSection = useMemo(() => transformCommentsForSection(rawComments), [rawComments]);

  const handleSubmitComment = async (data) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('You must be logged in to comment.');
        loginAction.onLogin();
        return;
      }

      const payload = {
        content: data.text,
        mapMarker: property._id,
      };

      if (data.parentId) {
        payload.parentComment = data.parentId;
      }

      await axios.post(API_ENDPOINT, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const response = await axios.get(`${API_ENDPOINT}?mapMarker=${property._id}`);
      setRawComments(response.data || []);
      if (property.onCommentAdded) {
        property.onCommentAdded((response.data || []).length);
      }

    } catch (error) {
      console.error('Error posting comment:', error.response ? error.response.data : error.message);
      alert('Failed to post comment. Please try again.');
    }
  };

  const loginAction = useMemo(() => ({
    onLogin: () => {
        alert('Login to comment. Please implement your login redirection.');
        // window.location.href = '/login';
    },
    signUpLink: '/signup'
  }), []);

  const handleLike = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('You must be logged in to like this post.');
        loginAction.onLogin();
        return;
      }

      // Assuming there's an API endpoint to update the like count
      const API_LIKE_ENDPOINT = config.getAllURL + 'api/like'; // Replace with the actual endpoint
      const API_CHECK_LIKE_ENDPOINT = config.getAllURL + 'api/like/checkLike';

      const checkLikeResponse = await axios.post(API_CHECK_LIKE_ENDPOINT, {
        mapMarker: property._id,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const alreadyLiked = checkLikeResponse.data.liked;

      await axios.post(API_LIKE_ENDPOINT, {
        mapMarker: property._id,
        liked: !alreadyLiked,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setLikeCount(prevLikeCount => alreadyLiked ? prevLikeCount - 1 : prevLikeCount + 1);
    } catch (error) {
      console.error('Error liking post:', error.response ? error.response.data : error.message);
      alert('Failed to like post. Please try again.');
    }
  };

  const handleCommentIconClick = () => setCommentPanelVisible(!commentPanelVisible);
  const handleSave = () => alert('Save functionality is not implemented yet.');
  const handleShare = () => alert('Share functionality is not implemented yet.');

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        if (commentPanelVisible) setCommentPanelVisible(false);
        else setShowPopup(false);
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [setShowPopup, commentPanelVisible]);

  const currentMedia = property.media?.[currentMediaIndex];

  const handleSwipe = (e) => {
    // Prevent swipe on media if comment panel is open
    if (commentPanelVisible) {
      return;
    }

    if (e.event.target.tagName === 'BUTTON' || e.event.target.closest('[data-element="comment-section-container"]')) {
        return;
    }

    if (property.media && property.media.length > 1) {
      if (e.dir === 'Left') handleNextMedia();
      else if (e.dir === 'Right') handlePrevMedia();
    }
  };

  // New swipe handlers specifically for the comment header drag icon
  // const commentHeaderSwipeHandlers = useSwipeable({
  //   onSwipedDown: () => setCommentPanelVisible(false),
  //   preventDefaultTouchmoveEvent: true,
  //   trackMouse: true,
  //   delta: { down: 3 },
  // });

  const [startTouchY, setStartTouchY] = useState(null);

  const handleTouchStart = (e) => {
    setStartTouchY(e.touches[0].clientY);
  };


 const handleScrollMove = (e) => {
    return; // allow normal even to happen, which is scroll
 }

 const handleTouchMove = (e) => {
    if (startTouchY === null) return;
    const touchMove = e.touches[0].clientY;
    if (touchMove > startTouchY + 10) { // Adjust sensitivity as needed
      setCommentPanelVisible(false);
    }
  };

  const handleTouchEnd = () => {
    setStartTouchY(null);
  };

  const handleNextMedia = (e) => {
    e?.stopPropagation();
    if (property.media && property.media.length > 0) {
      setCurrentMediaIndex((prevIndex) => (prevIndex + 1) % property.media.length);
    }
  };
  const handlePrevMedia = (e) => {
    e?.stopPropagation();
    if (property.media && property.media.length > 0) {
      setCurrentMediaIndex((prevIndex) => (prevIndex === 0 ? property.media.length - 1 : prevIndex - 1));
    }
  };

  const timeAgo = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 2) return 'just now';
    if (diffInSeconds < 60) return `${diffInSeconds}s ago`;

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) return `${diffInDays}d ago`;

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) return `${Math.floor(diffInDays / 30)}mo ago`;

    return `${Math.floor(diffInMonths / 12)}y ago`;
  };

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: '#333', display: 'flex',
        justifyContent: 'center', alignItems: 'center', 
        // zIndex: 1000,
        zIndex: 999999,
      }}
      onClick={() => {
        console.log(' ***** Popup clicked *****', currentMarkerIndex);
        if (commentPanelVisible) setCommentPanelVisible(false);
        else setShowPopup(false);
      }}
    >
      <div
        style={styles.reelContainer}
        onClick={(e) => {
          console.log('*** popup v3 clicked ****');
          console.log(currentMarkerIndex)
          e.stopPropagation()

        }}
      >
        <button style={styles.closeButton} onClick={() => setShowPopup(false)} aria-label="Close popup">
          &times;
        </button>


        <div
          {...swipeHandlers}
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
            touchAction: 'pan-y',
          }}
        >
          {currentMedia?.url && (
            <div
              // {...swipeHandlers}

            >
              {currentMedia.type === 'video' && !/\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url) ? (

              <video
                key={currentMedia.url}
                src={`https://${currentMedia.url}`}
                poster={property.thumbnailUrl || ''}
                style={styles.reelContent}
                autoPlay
                loop
                playsInline
                muted={false}
                ref={videoRef}
                onCanPlayThrough={(e) => {
                  console.log('Video onCanPlayThrough event fired.');
                  if (
                    audioRef.current &&
                    !isAudioPlaying &&
                    property.soundtrackUrl &&
                    property.soundtrackUrl.trim() !== ''
                  ) {
                    audioRef.current.loop = false;
                    audioRef.current
                      .play()
                      .then(() => {
                        console.log('Audio play successful on video canplaythrough.');
                      })
                      .catch((error) => {
                        console.error('Audio play failed:', error);
                      });
                  }
                }}
                onPlay={(e) => {
                  console.log('Video onPlay event fired.');
                  if (
                    audioRef.current &&
                    !isAudioPlaying &&
                    property.soundtrackUrl &&
                    property.soundtrackUrl.trim() !== ''
                  ) {
                    audioRef.current
                      .play()
                      .then(() => {
                        console.log('Audio play successful on video play.');
                      })
                      .catch((error) => {
                        console.error('Audio play failed:', error);
                      });
                  }
                }}
                onPause={() => {
                  console.log('Video onPause event fired.');
                  if (audioRef.current) {
                    console.log('Pausing audio on video pause.');
                    audioRef.current.pause();
                  }
                }}
                onEnded={() => {
                  console.log('Video onEnded event fired.');
                  if (audioRef.current) {
                    console.log('Pausing audio on video end.');
                    audioRef.current.pause();
                  }
                }}
              >
                Your browser does not support the video tag.
              </video>


              ) : (
                <div style={{ position: 'absolute', width: '100%', height: '100%'}}>
                  <img
                    key={currentMedia.url} src={`https://${currentMedia.url}`} alt={property.title || 'Property image'}
                    style={styles.reelContent} onError={(e) => console.error('Image failed to load:', currentMedia.url, e)}
                  />
                  {/* {property.media && property.media.length > 1 && (
                    <>
                      <button style={{...styles.navButton, ...styles.prevButton}} onClick={handlePrevMedia} aria-label="Previous media">{'‹'}</button>
                      <button style={{...styles.navButton, ...styles.nextButton}} onClick={handleNextMedia} aria-label="Next media">{'›'}</button>
                    </>
                  )} */}
                </div>
              )}
              <div style={styles.dotsContainer}>
                    {property.media.map((_, index) => (
                      <div
                        key={index}
                        style={{
                          ...styles.dot,
                          ...(index === currentMediaIndex ? styles.activeDot : {}),
                        }}
                      ></div>
                    ))}
                  </div>
            </div>
          )}
        </div>
        <div style={styles.overlay}>
          <div style={styles.bottomInfo}>
            <div style={styles.username}>
              <span>{property.title || property.address || 'Property Listing'}</span>
            </div>
            <div style={styles.caption}> {property.description} </div>
            <div style={styles.soundInfo}>
              <span>📅</span>
              <span>{timeAgo(property.createdAt)}</span>
            </div>
          </div>

          <div style={styles.sidebar}>
            <div style={{ position: 'relative', marginBottom: '20px' }}>
              <img
                src={property.userProfileImage || 'https://ui-avatars.com/api/?name=P&background=random&color=fff'}
                alt="User profile" style={{ width: '50px', height: '50px', borderRadius: '50%', border: '2px solid white', objectFit: 'cover' }} />
            </div>
            <IconPlaceholder label="❤️" count={likeCount} onClick={handleLike} />
            <IconPlaceholder label="💬" count={commentDataForSection.length || property.commentCount || 0} onClick={handleCommentIconClick} />
            <IconPlaceholder label="💾" count={property.saveCount || 'N/A'} onClick={handleSave} />
            <IconPlaceholder label="➤" count={property.shareCount || 'N/A'} onClick={handleShare} />
            <SoundIconPlaceholder imageUrl={property.soundImageUrl || 'https://ui-avatars.com/api/?name=S&background=random&color=fff'} />
          </div>
        </div>

        {commentPanelVisible && (
          <div
            style={{
              ...styles.commentSectionContainer,
              transform: commentPanelVisible ? 'translateY(0%)' : 'translateY(100%)',
            }}
            onClick={(e) => e.stopPropagation()}        
            data-element="comment-section-container"
          >
            <div
              style={styles.commentSectionHeader}
              // {...commentHeaderSwipeHandlers}
              onTouchStart={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleTouchStart(e);
              }}
              onTouchMove={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleTouchMove(e);
              }}
              onTouchEnd={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleTouchEnd(e);
              }}
              onClick={(e) => e.stopPropagation()}
            >
                <div
                    style={styles.commentDragIcon}
                ></div>
            </div>
            <div 
              onTouchStart={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleTouchStart(e);
              }}
              onTouchMove={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleScrollMove(e);
              }}
              onTouchEnd={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleTouchEnd(e);
              }}                 
              style={styles.commentSectionContent}
            >
                {/* <CommentSection
                    currentUser={currentUserData}
                    logIn={loginAction}
                    commentData={commentDataForSection}
                    onSubmitAction={handleSubmitComment}
                    currentData={(data) => { 
                      // console.log('current data from react-comments-section: ', data);  
                    }}
                    placeholder="Add a public comment..."
                /> */}

                {/* {comments.map((comment) => { */}
                


                {commentDataForSection.map((comment) => {
                // {commentData.comments.map((comment) => {
                  console.log("****** popup_v3.js*****")
                  console.log("Rendering comment:", comment); // ← this logs each comment object

                  return (
                    <Comment
                      key={comment.comId}
                      // commentData={comment}
                      commentData={comment}
                      updateScore={updateScore}
                      updateReplies={updateReplies}
                      editComment={editComment}
                      commentDelete={commentDelete}
                      setDeleteModalState={setDeleteModalState}
                    />
                  );
                })}
                
                {/* <AddComment buttonValue={"send"} onSubmit={handleSubmitComment} 
                  style={{
                    position: "fixed",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    backgroundColor: "#fff", // optional for visibility
                    padding: "1rem",         // adjust spacing
                    zIndex: "1000"           // make sure it's on top
                  }}                
                /> */}



            </div>

            <div style={styles.addCommentContainer}>
                  <AddComment
                    buttonValue={"send"}
                    onSubmit={handleSubmitComment}
                  />
            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default Popup;
